import React, { PropsWithChildren } from 'react';
import { Modifier } from '../../../../lib/bemUtils/Modifier';
import bem from '../../../../lib/bemUtils/bem';

type MetaInfoDescription = { term: string; className?: string; modifierDescription?: Modifier<'content-note'> };

export function MetaInfoDescription({
  term,
  className = '',
  modifierDescription,
  children,
}: PropsWithChildren<MetaInfoDescription>) {
  return (
    <>
      <dt className={className || 'meta-info__listelement font-bold-15-19'}>{`${term}: `}</dt>
      <dd className={bem('meta-info__listelement-desc', modifierDescription)}>{children}</dd>
    </>
  );
}
